<template>
  <div>
    <template v-if="joboffer && jobDetails">
      <job-row-view
        v-if="joboffer && jobDetails"
        :apiUrl="apiUrl"
        :joboffer="joboffer"
        :jobDetails="jobDetails"
        :slug="slug"
        :class="`company_${currentCompanyId}`"
      />
    </template>

    <template v-else>
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3">
          <div style="height: calc(100vh - 250px); padding-top: 250px">
            <v-progress-linear
              indeterminate
              rounded
              color="primary"
              height="10"
            />
          </div>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import jobRowView from '@/components/jobDetails/job-details-column-view.vue';
import TrackingService from '@/services/TrackingService.js';

export default {
  data: () => ({
    joboffer: null,
    jobDetails: null
  }),

  watch: {
    $route() {
      this.initialize();
    },

    joboffers() {
      if (!this.joboffer) {
        this.initialize();
      }
    }
  },

  computed: {
    ...mapState('jobsModule', {
      joboffers: 'joboffers'
    }),

    ...mapState('companyModule', {
      slug: 'slug',
      currentCompanyId: 'currentCompanyId'
    }),

    ...mapGetters('companyModule', {
      isInternal: 'userIsInternal',
      apiUrl: 'currentCompanyApiUrl'
    }),

    jsonld() {
      if (!this.jobDetails) {
        return {};
      }

      return this.jobDetails.google4JobsData;
    }
  },

  async mounted() {
    this.setCurrentJob({ joboffer: null, jobDetails: null });

    if (this.joboffers && this.joboffers.length > 0) {
      await this.initialize();
    } else {
      this.redirect404();
    }
  },

  methods: {
    ...mapActions('jobsModule', {
      loadJobDetails: 'loadJobDetails',
      loadJobs: 'loadJobs'
    }),

    ...mapMutations({
      setHeroClaim: 'setHeroClaim',
      setCurrentJob: 'jobsModule/setCurrentJob',
      setCompanyId: 'companyModule/setCurrentCompanyId'
    }),

    async initialize() {
      const jobId = this.$route.params.jobId;

      const job = this.joboffers.find(
        (x) => x.jobofferId.toString() === jobId.toString()
      );

      if (!job) {
        this.redirect404();
        return;
      }

      this.joboffer = job;
      this.setHeroClaim(job.name);
      document.title = `${this.$t('jobs.joboffer')}: ${this.localize(
        job.name
      )} - ${this.localize(job.companyName)}`;

      const response = await this.loadJobDetails({
        slug: this.slug,
        jobofferId: jobId,
        isInternal: this.isInternal
      });

      this.jobDetails = response;
      this.$nextTick(() => {
        this.setCompanyId(response.companyId);
        TrackingService.flushPageView();
      });

      this.setCurrentJob({ joboffer: job, jobDetails: response });
      this.injectMetaData('og:title', this.localize(job.name));
      this.injectMetaData('og:url', window.location.href);

      if (response.content?.length) {
        this.injectMetaData(
          'og:description',
          this.localize(response.content[0].text[0])
        );

        this.injectMetaData(
          'description',
          this.localize(response.content[0].text[0])
        );
      }

      if (job.headerImages?.length) {
        this.injectMetaData('og:image', job.headerImages[0].imageUrl);
      }

      this.injectJobPosting();
    },

    injectMetaData(name, content) {
      let metaElement = document.querySelector(`head meta[name="${name}"]`);

      if (!metaElement) {
        metaElement = document.createElement('meta');
        document.head.appendChild(metaElement);
      }

      metaElement.name = name;
      metaElement.content = this.stripHtml(content);
    },

    injectJobPosting() {
      const scriptElement =
        document.querySelector('head script[id="jobInformationScript"]') ??
        document.createElement('script');
      scriptElement.id = 'jobInformationScript';
      scriptElement.type = 'application/ld+json';
      scriptElement.innerHTML = this.jsonld;
      document.head.appendChild(scriptElement);
    },

    redirect404() {
      window.location.href = `/${this.slug}/not-found`;
    },

    stripHtml(htmlContent) {
      const tmpElement = document.createElement('div');
      tmpElement.innerHTML = htmlContent;
      return tmpElement.textContent || tmpElement.innerText;
    }
  },

  components: {
    jobRowView
  }
};
</script>
